module.exports = __webpack_public_path__ + "static/media/learn3.586a3f1d.jpg";